var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"13338b81fc0833e7326ae75b7559baf9b898552d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@grailed"]={id:"13338b81fc0833e7326ae75b7559baf9b898552d"};
      